import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExclamationTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExclamationTriangle"><Path fillRule="evenodd" clipRule="evenodd" d="M1.18359 20.0003L12.0011 1.78125L22.8187 20.0003H1.18359ZM12.75 9.00024V14.5002H11.25V9.00024H12.75ZM11.25 15.5002H12.75V17.0002H11.25V15.5002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationTriangle;
